<script>
	import { slide } from "svelte/transition";
	export let photo;
	export let name;
	export let role = false;
</script>

<div
	class="grid mx-auto text-center text-white user justify-items-center {role?"role-"+role:""}"
	transition:slide
>
	<img
		class="h-20 my-4 border-4 border-white border-solid rounded-full"
		src={photo !== null
			? photo
			: "https://vutreshenglas.com/img/png/vg-profile-null.webp"}
		alt={name !== null ? name : "?"}
		referrerpolicy="no-referrer"
	/>
	<h1 class="self-center max-w-xs text-base text-center">
		{name !== null ? name : "?"}
	</h1>
</div>

<style>
</style>
